// frontend/src/hooks/dashboard/useOptimizablePDLs.js
import { useEffect, useState, useCallback } from 'react';
import { fetchWithAuth } from '../../services/api';

const ENDPOINT = '/api/dashboard/optimizable-pdls';

/**
 * Fetches the list of optimizable PDLs from the backend.
 * Uses fetchWithAuth (frontend/src/services/api.js) which automatically
 * injects the Supabase Bearer token — aligned with the project's auth pattern.
 *
 * `degraded` : sources que le backend n'a pas pu lire (ex. 'enedis_flags') ;
 * `warnings` : messages correspondants, à afficher tels quels.
 *
 * @returns {{ data: Array, degraded: string[], warnings: string[], loading: boolean, error: Error|null, refetch: Function }}
 */
export function useOptimizablePDLs() {
  const [data, setData] = useState([]);
  const [degraded, setDegraded] = useState([]);
  const [warnings, setWarnings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOnce = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const json = await fetchWithAuth(ENDPOINT);
      setData(json?.data || []);
      setDegraded(Array.isArray(json?.degraded) ? json.degraded : []);
      setWarnings(Array.isArray(json?.warnings) ? json.warnings : []);
    } catch (e) {
      console.error('[useOptimizablePDLs] fetch error:', e);
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOnce();
  }, [fetchOnce]);

  return { data, degraded, warnings, loading, error, refetch: fetchOnce };
}
